import {
  CABIN_CONTENTS_ABOUT_STEP,
  CABIN_CONTENTS_INTRO_STEP,
  CABIN_CONTENTS_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/CabinContents";
import {
  booleanToFormBoolean,
  nullableBooleanToNullableFormBoolean,
} from "Utils/formUtils";

import { BooleanFormType } from "Store/interfaces/FormTypes";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { mapInjuriesToForm } from "Store/priceCalculation/productMappers/common/injuriesMapper";

export function mapFromCommerceCabinContents(data: {
  [key: string]: any;
}): FormStates {
  return {
    [CABIN_CONTENTS_INTRO_STEP.id]: {
      postNumber: data.address?.zipCode,
      validPostNumber: true,
      city: data.address?.city,
    },
    [CABIN_CONTENTS_ABOUT_STEP.id]: {
      hasElectricity: booleanToFormBoolean(data.hasElectricity),
      hasTapWater: booleanToFormBoolean(data.hasTapWater),
      hasRental: nullableBooleanToNullableFormBoolean(data.hasRental),
      rentalTimeExceedsOneMonthAYear: BooleanFormType.FALSE,
      contentsInsuranceSum: data.coverageAmountCabinContent,
      ...mapInjuriesToForm(data.damageCountRecentYears, data.yearOfLastDamage),
    },
    [CABIN_CONTENTS_PRICE_STEP.id]: {
      coverage: data.coverageGroup,
      deductible: data.priceSpecifications.deductible.code,
    },
  };
}
